module.exports = Promise.all([__parcel__import__("86Vt4"), __parcel__import__("i9vec")]).then(() => parcelRequire('g36Vt'));